<template>

  <div>
    <el-table
      :data="tableDataHobby"
      border
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">

      <el-table-column
        prop="count"
        label="编号"
        width="60">
      </el-table-column>

      <el-table-column
        label="图片"
        width="85">
        <template slot-scope="scope">
          <img :src="scope.row.picUrl" height="60px" width="60px"
               style="border-radius: 50%">
        </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="标题"
        width="120">
      </el-table-column>

      <el-table-column
        prop="content"
        label="介绍"
        width="400">
      </el-table-column>

      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--    添加按钮-->
    <el-button @click="addSkill()" style="margin-top: 20px" type="primary" plain>添加内容</el-button>
    <el-dialog title="添加技能" :visible.sync="addFormVisible" width="500px" top="10px"
               @close="cancel('addData')"
    >
      <el-form :model="addData" :rules="rules" ref="addData" label-width="100px" class="demo-ruleForm">

        <el-form-item label="头像" prop="picUrl" style="margin: 20px 50px">
          <el-upload
            v-model="addData.picUrl"
            class="avatar-uploader"
            :action="uploadActionUrl+'/uploadImage'"
            name="image"
            :show-file-list="false"
            :on-success="addHandleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="addData.picUrl" :src="addData.picUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="标题:" prop="name" style="margin: 10px 50px">
          <el-input v-model="addData.name" style="width: 100px;margin-left: 10px"></el-input>
        </el-form-item>

        <el-form-item label="内容:" prop="content">
          <el-input style="width: 250px;margin-left: 10px;margin-top: 10px"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="addData.content">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleInsert('addData')">添加</el-button>
          <el-button @click="resetForm('addData')">重置</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>


    <!--    对话框-->
    <el-dialog title="爱好信息" :visible.sync="dialogFormVisible" width="500px" top="8%"
               @close="cancel('formData')"
    >

      <el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="demo-ruleForm">

        <el-form-item label="头像" prop="picUrl" style="width: 10px;margin: 0 50px">
          <el-upload
            v-model="formData.picUrl"
            class="avatar-uploader"
            :action="uploadActionUrl+'/uploadImage'"
            name="image"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="formData.picUrl" :src="formData.picUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="标题:" prop="name" style="margin: 10px 50px">
          <el-input v-model="formData.name" style="width: 100px;margin-left: 10px"></el-input>
        </el-form-item>

        <el-form-item label="内容:" prop="content">
          <el-input style="width: 250px;margin-left: 10px;margin-top: 10px"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="formData.content">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('formData')">提交</el-button>
          <el-button @click="resetForm('formData')">重置</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "CommentManager",
  data(){
    return {
      id: null,
      dialogFormVisible:false,
      addFormVisible:false,
      adminInfo:{},
      addData:
        {
          picUrl:null,
        name:null,
        content:null,
          adminId: null,
        },

      tableDataHobby: [
        {
          count:null,
          id: null,
          picUrl: null,
          name: null,
          content: null,
          adminId: null,
        }
    ],
      formData:{},
      rules:{
        //图片
        picUrl:[
          {required: true, message: '头像不能为空', trigger: 'blur'}
        ],
        //标题
        name:[
          {required:true,message:'请输入标题', trigger: 'blur'}
        ],
        //内容
        content:[
          {required:true,message:'请输入内容', trigger: 'blur'}
        ],

      },
      //图片上传路径
      uploadActionUrl: base_url

    }
  },

  methods:{

    //添加处理
    handleInsert(addData){
      let that=this;
      that.addData.adminId=that.id;
      this.$refs[addData].validate((valid)=>{
        if (valid){
          this.$confirm('此操作将添加用户信息，是否继续?','警告',{
            confirmButtonText:'确定',
            cancelButtonText:'取消',
            type:'warning'
          }).then(()=>{
            request({
              url:'/admin/insertAdminUserHobby',
              methods: 'get',
              params:{
                insertAdminUserHobby:that.addData,
                adminInfo:that.adminInfo,
              }
            }).then(response=>{
              this.addFormVisible=false;
              if (response.data.flag){
                this.$notify.success({
                  title:'添加',
                  duration:2000,
                  message:response.data.message
                });
                this.AdminUserListHobby();
              }
            })
          }).catch(()=>{
            this.$message({
              type:'success',
              message:'已取消',
            });
          })
        }
      })
    },

    //添加按钮
    addSkill(){
      this.addFormVisible=true;

    },
    //删除
    handleDelete(index, row){
      let that=this;
      // console.log(row.id)
      this.$confirm('此操作将永久删除该文件, 是否继续?','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        request({
          url:'/admin/deltedAdminUserHobby',
          method:'get',
          params:{
            id:row.id,
            adminInfo:that.adminInfo,
          }
        }).then(repose=>{
          // console.log(repose);
          if (repose.data.flag){
            this.$notify.success({
              title:'删除',
              duration:2000,
              message:'删除成功！'
            });
            that.AdminUserListHobby();
          }else {
            this.$message({
              type: 'error',
              message: '删除失败!'
            })
          }
        })
      }).catch(()=>{
        this.$message({
          type:'success',
          message:'已取消'
        })
      })

    },
    //编辑
    handleEdit(index,row){
      this.formData=row;
      // console.log(this.formData)
      this.dialogFormVisible=true;
    },
    //重置
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    //编辑提交
    submitForm(formData){
      let that=this;
      // console.log(that.formData);
      this.$refs[formData].validate((valid)=>{
        if (valid){
          this.$confirm('此操作将修改用户信息，是否继续?',"警告",{
            confirmButtonText:'确定',
            cancelButtonText:'取消',
            type:'warning'
          }).then(()=>{
            request({
              url:'/admin/updataAdminUserHobby',
              methods: 'get',
              params:{
                adminUserHobbyJson:that.formData,
                adminInfo:that.adminInfo,
              }
            }).then(response=>{
              that.dialogFormVisible=false;
              if (response.data.flag){
                  this.$notify.success({
                    title:'修改',
                    duration:2000,
                    message:response.data.message
                  });
                  this.AdminUserListHobby();
              }else{
                this.$notify.error({
                  title: '爱好',
                  duration: 2000,
                  message: '参数有误'
                });
              }
            })
          }).catch(()=>{
            this.$message({
              type:'success',
              message:'取消',
            });
          })
        }else {
          // console.log('error submit!!');
          return false
        }
      })
    },

    //处理头像之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },
    //编辑处理头像成功
    handleAvatarSuccess(result) {
      // console.log(result)
      if (result.flag) {
        this.formData.skillPic = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }
    },

    //添加处理头像成功
    addHandleAvatarSuccess(result) {
      // console.log(result)
      if (result.flag) {
        this.addData.picUrl = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }
    },

    //取消修改用户
    cancel(formName){
      this.$refs[formName].resetFields();
      this.editDialogVisible = false;
    },

    // 获取管理员爱好信息
    AdminUserListHobby(){
      let that=this;

      request({
        url:'/admin/getAdminHobby',
        method:'get',
        params:{
          id:that.id,
        }
      }).then(response=>{
        if (response.data.data==null){

        }else{
          let count=1;
          response.data.data.forEach(values=>{
            values.count=count++;
            values.picUrl=base_url+'/getImage/'+values.picUrl;

          })
        }

        that.tableDataHobby=response.data.data;
      })
    },

  },

  mounted() {
    var item = window.sessionStorage.getItem('adminInfo');
    let data = JSON.parse(item);
    this.id=data.id
    this.adminInfo=data;
    this.AdminUserListHobby();
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}

.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/HobbyManager.vue